<template>

    <div :class="{'servertable':true,'resizing':this.columnMove.moving}" ref="servertable">
        <div class="servertable-tools">
            <div class="servertable-actions">
                <button type="button" v-if="addUrl !== null" class="add" @click="gotoAdd()"><i class="mdi mdi-plus"></i></button>
                <button type="button" :disabled="hasActiveButtons && show.exportoption !== true" :class="{'active':show.exportoption,'servertable-action':true}" @click="show.exportoption = !show.exportoption"><i class="mdi mdi-application-export servertable-action"></i></button>
                <button type="button" :disabled="hasActiveButtons && show.columns !== true" :class="{'active':show.columns,'servertable-action':true}" @click="show.columns = !show.columns"><i class="mdi mdi-format-columns servertable-action"></i></button>
                <button type="button" :disabled="hasActiveButtons && show.filters !== true" :class="{'active':show.filters,'servertable-action':true}" @click="show.filters = !show.filters"><i class="mdi mdi-filter servertable-action"></i></button>
            </div>
            <div class="servertable-search">
                <div>
                    <span>
                        <button type="button" @click="execSearch()" :disabled="!canSearch"><i class="mdi mdi-magnify"></i></button>
                    </span>
                    <input type="text" v-model="search.value" :placeholder="lang.get('servertable.search')" @keydown.enter="execSearch()" :disabled="!canSearch" />
                </div>
            </div>
            <div class="servertable-active-filters" v-show="activeFilters.length > 0">
                <span
                    v-for="filter in activeFilters"
                    @click="onFilterChange(filters[filter])"
                >
                    {{ filters[filter].name }}
                    <i class="mdi mdi-close"></i>
                </span>
            </div>
            <span class="servertable-total-records">{{ lang.get('servertable.number_of_results') }}: {{ total }}</span>
        </div>
        <div class="servertable-header"
            ref="servertableheaderelement"
        >
            <div class="servertable-row"
                @mousemove="onMousemove"
                :style="{minWidth:getMinWidth + 'px'}"
            >
                <div
                    v-for="column in activeColumns"
                    :class="{'servertable-cell':true,'sortable':column.sortable === true}"
                    :style="{width:column.width + 'px'}"
                    @click="setSortByColumn(column)"
                >
                    <span class="servertable-cell-text" v-text="column.name"></span>
                    <span class="servertable-sorting" v-show="sorting.sorting && sorting.columnId === column.id">
                        <i class="mdi mdi-sort-ascending" v-show="sorting.direction === 'asc'"></i>
                        <i class="mdi mdi-sort-descending" v-show="sorting.direction === 'desc'"></i>
                    </span>
                    <span class="servertable-cell-trigger"
                        @mousedown="onMousedown($event,column)"
                    ></span>
                </div>
            </div>
        </div>
        <div class="servertable-body"
            @scroll="onScroll"
            :style="{height:bodyHeight + 'px'}"
        >
            <div
                v-if="getData.length === 0"
                class="servertable-row"
            >
                <div class="servertable-cell" style="width:100%;" v-text="lang.get('servertable.no_results')"></div>
            </div>
            <div
                v-for="(row,key) in getData"
                :class="{'servertable-row':true,'servertable-row-selected':selectedRows.indexOf(key) !== -1 || filters.selectedrows.enabled === true}"
                :style="{minWidth:getMinWidth + 'px'}"
                @click="onRowSelected(key)"
                @dblclick="onDoubleClick(row)"
            >
                <div
                    v-for="column in activeColumns"
                    class="servertable-cell"
                    :style="{width:column.width + 'px'}"
                >
                    <em
                        v-if="row[column.id] === '%%hidden%%'"
                        class="servertable-cell-text"
                    >
                        {{ lang.get('global.hidden') }}
                    </em>
                    <span
                        v-else
                        class="servertable-cell-text"
                        v-text="row[column.id]"
                    ></span>
                </div>

            </div>
        </div>
        <div class="servertable-resizer-left" :style="{left:resizers.left + 'px', display:this.columnMove.moving ? 'block' : 'none'}"></div>
        <div class="servertable-resizer-right" :style="{left:resizers.right + 'px', display:this.columnMove.moving ? 'block' : 'none'}"></div>
        <div class="servertable-loader" v-show="loadingData">
            <i class="mdi mdi-spin mdi-progress-download"></i>
        </div>
        <div class="servertable-error" v-show="loadingError">
            <div>
                {{ lang.get('servertable.error') }}
            </div>
        </div>
        <div class="servertable-overlayview servertable-active-columns" v-show="show.columns" v-click-outside="closeShow">
            <table>
                <thead>
                    <tr>
                        <td colspan="2">{{ lang.get('servertable.allcolumns') }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="column in columns">
                        <td><input type="checkbox" :id="'cbox-' + column.id" :checked="column.active" :value="column.id" @change="toggleColumn(column)" /></td>
                        <td><label :for="'cbox-' + column.id" v-text="column.name"></label></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="servertable-overlayview servertable-filters" v-show="show.filters">
            <table>
                <thead>
                    <tr>
                        <td colspan="2">{{ lang.get('servertable.allfilters') }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="filter in filters">
                        <td><input type="checkbox" :id="'cbox-' + filter.id" :checked="filter.enabled" :value="filter.id" @change="onFilterChange(filter)" /></td>
                        <td><label :for="'cbox-' + filter.id" v-text="filter.name"></label></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="servertable-overlayview servertable-export" v-show="show.exportoption">
            <json-excel
                :data="getExportData"
                :fields="getColumnsForExcel"
                class="anchorelement"
            >
                <i class="mdi mdi-file-excel-box"></i>
            </json-excel>
            <button type="button" class="anchorelement" @click="exportToPdf()">
                <i class="mdi mdi-file-pdf-box"></i>
            </button>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import JsonExcel from 'vue-json-excel';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import Lang from '../../Lang';

export default {

    beforeDestroy() {
        document.documentElement.removeEventListener("mouseup", this.stopMove);
    },

    components: {
        JsonExcel,
    },

    computed: {
        activeColumns() {
            return this.columns.filter(column => column.active === true);
        },
        activeFilters() {
            return Object.keys(this.filters)
                .filter(filter => this.filters[filter].enabled === true);
        },
        canSearch() {
            return !this.hasActiveButtons && !this.hasActiveFilters;
        },
        getExportData() {
            return this.getData.map(entry => {
                let data = {};
                for (const [key, value] of Object.entries(entry)) {
                    if (/date/.test(key)) {
                        data[key] = moment(value).format('YYYY-MM-DD');
                    } else {
                        data[key] = value;
                    }
                }
                return data;
            });
        },
        getData: {
            get() {
                let data = this.data;
                if (this.activeFilters.length > 0) {
                    this.activeFilters.forEach(filter => {
                        if (this.filters[filter].hasOwnProperty("getData")) {
                            data = this.filters[filter].getData();
                        }
                    });
                }
                return data;
            },
        },
        getDataParams() {
            let params = {
                items:this.itemsPerPage,
                page:this.currentpage,
            };
            // Check sorting
            if (this.sorting.sorting === true) {
                params.sortBy = this.sorting.columnId;
                params.sortDir = this.sorting.direction;
            }
            // Check search
            if (this.search.value !== "") {
                params.search = this.search.value;
            }
            // Add the enabled filters
            params.filters = this.activeFilters;
            return params;
        },
        getColumnsForExcel() {
            let columns = {};
            this.columns.forEach(column => {
                if (column.active === true) {
                    columns[column.name] = column.id;
                }
            });
            return columns;
        },
        getColumnsForPdf() {
            let columns = [];
            this.columns.forEach(column => {
                if (column.active === true) {
                    columns.push({
                        title:column.name,
                        dataKey:column.id,
                    });
                }
            });
            return columns;
        },
        getMinWidth() {
            let width = 0;
            this.columns.forEach(column => width += (column.active === true ? column.width : 0));
            return width;
        },
        hasActiveButtons(){
            return this.show.columns === true ||
                this.show.exportoption === true ||
                this.show.filters === true;
        },
        hasActiveFilters() {
            return this.filters.selectedrows.enabled === true;
        },
    },

    data() {
        return {
            bodyHeight:400,
            columnMove: {
                minX:0,
                moving:false,
                column:null,
            },
            columns:[],
            currentpage:1,
            data:[],
            fetchingdata:false,
            filters:{
                selectedrows: {
                    name:Lang.get("servertable.selectedrows"),
                    id:"selectedrows",
                    enabled:false,
                    getData:() => {
                        let data = [];
                        this.selectedRows.forEach(index => data.push(this.data[index]));
                        return data;
                    },
                },
            },
            lang:Lang,
            loadingData:false,
            loadingError:false,
            previousSearch:"",
            resizers:{
                left:0,
                right:0,
            },
            search: {
                value:'',
            },
            selectedRows:[],
            show: {
                columns:false,
                exportoption:false,
                filters:false,
            },
            sorting: {
                sorting:false,
                direction:null,
                columnId:null,
            },
            total:0,
            totalPages:1,
        }
    },

    directives: {
        clickOutside: {
            bind: function(el, binding, node) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his childrens
                    if (!(el === event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        node.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
        },
    },

    methods: {
        calcTotalPages() {
            let calc = Math.ceil(this.total / this.itemsPerPage);
            this.totalPages = calc < 1 ? 1 : calc;
        },

        closeShow(el) {
            if (el.target.classList.contains("servertable-action")) {
                return;
            }
            if (this.show.columns) {
                this.show.columns = false;
            }
            if (this.show.exportoption) {
                this.show.exportoption = false;
            }
            if (this.show.filters) {
                this.show.filters = false;
            }
        },

        execSearch() {
            if (!this.canSearch || this.previousSearch === this.search.value){
                return;
            }
            // Check search length
            if (this.search.value.length > 0 && this.search.value.length < 3) {
                this.$snotify.info('Use at least three characters when searching');
                return;
            }
            this.resetData();
            this.previousSearch = this.search.value;
        },

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            doc.autoTable({
                columns:this.getColumnsForPdf,
                body:this.getData,
                startY:20,
                didDrawPage: function(data) {
                    if (data.table.pageNumber === 1) { // Only for the first page
                        doc.setFontSize(12);
                        doc.text("Exportdatum: " + moment().format("DD-MM-YYYY HH:mm"), data.settings.margin.left, data.settings.margin.top)
                    }
                },
            });
            doc.save('export.pdf');
        },

        fetchData(showloader = true) {
            if (this.fetchingdata === true) {
                return;
            }
            this.fetchingdata = true;
            this.loadingData = showloader;
            axios.get(this.dataUrl,{params: this.getDataParams})
            .then(resp => {
                this.fetchingdata = false;
                this.loadingData = false;
                this.data = this.data.concat(resp.data.data);
                this.total = resp.data.total;
                this.calcTotalPages();
                this.setHeight();
            })
            .catch(err => {
                this.loadingError = true;
            });
        },

        gotoAdd() {
            if (this.addUrl !== null) {
                this.$router.push(this.addUrl);
            }
        },

        onDoubleClick(row) {
            this.$emit("double-clicked-row", row);
        },

        onFilterChange(filter) {
            // Toggle enabled state
            filter.enabled = !filter.enabled
            // Check if the filter has an onChange property
            if (filter.hasOwnProperty("onChange")) {
                filter.onChange();
            }
        },

        onMousedown(event, column) {
            this.columnMove.column = column;
            this.columnMove.minX = event.target.parentNode.offsetLeft + event.target.parentNode.querySelectorAll('.servertable-cell-text')[0].offsetWidth + 20;
            this.resizers.left = event.target.parentNode.offsetLeft;
            this.resizers.right = event.target.parentNode.offsetLeft + column.width;
            this.columnMove.moving = true;
        },

        onMousemove(event) {
            if (this.columnMove.moving) {
                let currentX = (event.clientX - 15) - parseInt($('.content-wrapper').css('margin-left').replace('px',''));
                if (currentX >= this.columnMove.minX) {
                    this.resizers.right = currentX;
                }
            }
        },

        onRowSelected(key) {
            if (this.selectedRows.indexOf(key) === -1) {
                this.selectedRows.push(key);
            } else {
                this.selectedRows.splice(this.selectedRows.findIndex(row => row === key), 1);
            }
        },

        onScroll ({ target: { scrollTop, clientHeight, scrollHeight, scrollLeft }}) {
            this.$refs.servertableheaderelement.scrollLeft = scrollLeft;
            if (scrollTop + clientHeight >= (scrollHeight - (30 * 20))) { // 20 rows
                if (this.currentpage < this.totalPages && !this.fetchingdata) {
                    this.currentpage++;
                    this.fetchData(false);
                }
            }
        },

        parseColumns() {
            let columns = JSON.parse(this.dataColumns);
            columns.forEach(column => {
                if (!column.active && column.active !== false) {
                    column.active = true;
                }
            });
            this.columns = columns;
        },

        resetData(showloader = true) {
            this.selectedRows = [];
            this.currentpage = 1;
            this.data = [];
            this.total = 0;
            this.fetchData(showloader);
        },

        setHeight() {
            this.bodyHeight = window.innerHeight - this.$refs.servertable.offsetTop - 100;
        },

        setSortByColumn(column) {
            // Make sure we're not still moving
            if (column.sortable !== true || this.columnMove.moving === true) {
                return;
            }
            // Check current sorting
            if (this.sorting.sorting === true) {
                // Set sorting
                this.sorting = {
                    sorting:this.sorting.direction !== "desc",
                    direction:this.sorting.direction === "desc" ? null : "desc",
                    columnId:this.sorting.direction === "desc" ? null : column.id,
                };
            } else {
                this.sorting = {
                    sorting:true,
                    direction:"asc",
                    columnId:column.id,
                };
            }
            this.resetData();
        },

        stopMove() {
            if (this.columnMove.column !== null) {
                this.columnMove.column.width = (this.resizers.right - this.resizers.left);
                this.$emit("after-column-resize", JSON.parse(JSON.stringify(this.columnMove.column)));
            }
            this.columnMove.column = null;
            setTimeout(() => {
                this.columnMove.moving = false;
            }, 50);
        },

        toggleColumn(column) {
            column.active = !column.active;
            this.$emit("after-column-active-toggle", column);
        },
    },

    mounted() {
        // Create event listeners
        document.documentElement.addEventListener("mouseup", this.stopMove);
        // Fire some bootup methods
        this.parseColumns();
        this.setHeight();
        this.fetchData();
    },

    name:"ServerTable",

    props: {
        addUrl:{
            type:String,
            default:null,
        },
        dataUrl:{ required:true },
        dataColumns: {
            required:true,
            type:String,
        },
        itemsPerPage: {
            type:Number,
            default:100,
        },
    },

}

</script>

<style lang="scss">

$base-border-color: #ccc;
$primary-border-color: #d3dbe1;
$base-text-color: #333;
$header-background-color: #f5f5f5;
$base-row-height: 30px;
$row-background-even:#f0f2f4;
$hover-row-background-color:#ebebeb;
$selected-row-background-color:#428bca;
$selected-row-hover-background-color:#2972b1;
$archibase-orange:#ff9600;

.servertable {

    position:relative;
    overflow:hidden;
    border:1px solid $primary-border-color;
    width:100%;
    margin-bottom:10px;
    background-color:#fff;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */

    &.resizing {
        cursor:col-resize !important;
    }

    button {
        border:0;
        color: $base-text-color;
        height: $base-row-height;
        width: 21px;
        background-color:$header-background-color;
        transition:background-color 0.2s ease-in-out, color 0.2s ease-in-out;

        &:hover,
        &.active {
            background-color:#fff;
        }

        &:disabled {
            background-color:#dcdcdc;
            color:#ccc;
        }
    }

    .servertable-tools {
        display: flex;
        text-align:left;
        overflow:hidden;
        height:$base-row-height;
        background-color:$header-background-color;
        border-bottom:1px solid $base-border-color;

        .servertable-total-records {
            line-height:$base-row-height;
            padding:0 8px;
        }

        .servertable-active-filters {
            height:$base-row-height;
            line-height:$base-row-height;
            padding: 0 8px;
            border-left:1px solid $primary-border-color;

            span {
                border:1px solid blue;
                padding:2px 5px;
                cursor:pointer;
                margin-left:4px;
            }
        }

        .servertable-search {

            div {
                position:relative;
                display:Table;
                border-collapse:separate;
                border-right:1px solid $base-border-color;

                input {
                    border:0;
                    background-color:#fff;
                    color: $base-text-color;
                    height:$base-row-height;
                    padding:0 8px;
                    transition:width 0.2s ease-in-out, background-color 0.2s ease-in-out, color 0.2s ease-in-out;
                    width:150px;

                    &:focus {
                        width:300px;
                        border:0;
                    }

                    &:disabled {
                        background-color:#dcdcdc;
                        color:#ccc;
                    }
                }

                span {
                    border-left:1px solid $base-border-color;
                    white-space:nowrap;
                    display:table-cell;
                }
            }
        }

        .servertable-actions {
            overflow:hidden;
            position:relative;

            > button {
                float:left;
                border-left:1px solid $base-border-color;

                &.add {
                    color: #fff;
                    background-color: $archibase-orange;
                }
            }
        }
    }

    .servertable-header {
        background-color:$header-background-color;
        overflow-x:hidden;

        .servertable-cell {
            padding:10px 8px;
            position:relative;

            &.sortable {
                cursor:pointer;
            }

            .servertable-cell-text {
                font-weight:700;
            }

            .servertable-cell-trigger {
                position:absolute;
                right:0;
                top:0;
                height:100%;
                width:10px;

                &:hover {
                    cursor:col-resize;
                }
            }
        }
    }

    .servertable-body {
        overflow-x:auto;

        .servertable-row:nth-child(even) {
            background-color:$row-background-even;
        }
    }

    .servertable-row {
        overflow:hidden;
        height:$base-row-height;
        border-width:0 0 1px 0;
        border-style:solid;
        border-color:$primary-border-color;
        transition:background-color 0.2s ease-in-out, color 0.2s ease-in-out;
    }

    .servertable-body .servertable-row {
        &.servertable-row-selected {
            background-color:$selected-row-background-color !important;
            color:#fff !important;

            &:hover {
                background-color:$selected-row-hover-background-color !important;
            }
        }
        &:not(.servertable-row-selected):hover {
            background-color:$hover-row-background-color !important;
            color:$base-text-color !important;
        }
    }

    .servertable-cell {
        float:left;
        height:$base-row-height;
        margin-left:0;
        border-width:0 1px 0 0;
        border-style:solid;
        border-color:$primary-border-color;
        cursor:default;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        text-align:left;
        box-sizing:border-box;
        padding:7px 8px;
        transition:width 0.2s ease-in-out;
    }

    .servertable-resizer-left,
    .servertable-resizer-right {
        height:100%;
        position:absolute;
        top:0;
        border-right:2px dashed rgba(81,103,122,.5);
        z-index:1;
    }

    .servertable-loader,
    .servertable-error {
        position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background-color:#ccc;
        z-index:10;
        font-size:6em;
        text-align:center;

        > i,
        > div {
            position:absolute;
            top:50%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
        }

        > div {
            text-align: center;
            width:100%;
        }
    }

    .servertable-error {
        font-size:2em !important;;
    }

    .servertable-loader {
        opacity:0.4;
        filter:alpha(opacity=40);
    }

    .servertable-overlayview {
        position:absolute;
        left:0;
        top:$base-row-height;
        background-color:#fff;
        border-left:1px solid $base-border-color;
        border-bottom:1px solid $base-border-color;
        box-shadow:-2px 2px 8px #ccc;
        padding:10px 12px;
        max-height:100%;
        overflow-y:auto;

        table th,
        table td {
            padding:2px 4px;
        }

        table th { font-weight:700; }

        label {
            font-weight:400;
            margin:0;
        }

        &.servertable-export .anchorelement {
            cursor:pointer;
            display:block;
            border:0;
            background-color:transparent;
            padding:5px;
            margin-bottom:10px;
            font-size:1.8em;
        }
    }
}

</style>
